module.exports = __webpack_public_path__ + "13752c270a29d3968bb3de3b8f983cb3.svg";